<script context="module">
</script>

<script>
  import { signInButton } from "../util/highlight-loader";

  function withButton(node, opts = {}) {
    signInButton.attach(node);
    return {
      destroy() {
        signInButton.detach();
      },
    };
  }
</script>

<div class="connect-button-container" use:withButton></div>

<style>
  :global(.connect-button) {
    /* flex-basis: 50%; */
    /* min-width: 130px; */
    flex-grow: 2;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    /* padding: 20px; */
  }
  :global(
      .connect-button-container
        .highlight-UnstyledButton-root
        .highlight-Text-root
    ) {
    /* color: pink !important; */
    /* min-width: 150px; */
  }
</style>
